import { IndexValue } from '../../../types/IndexValue';
import { GenericInput } from './GenericInput';
import { GenericInputProps } from './GenericInputProps';
import validateNumber from './OnlyNumbersEntry';

type ImputTextProps = {
  onlyNumbers?: boolean;
} & GenericInputProps<IndexValue>;

export function InputText(props: ImputTextProps) {
  return (
    <GenericInput
      required={props.required}
      placeholder={props.placeholder}
      name={props.name}
      type="text"
      disabled={props.disabled}
      tooltip={props.tooltip}
      label={props.label}
      icon={props.icon}
      formRegister={props.formRegister}
      maxLength={props.maxLength}
      minLength={props.minLength}
      validateFunction={props.validateFunction}
      errorCollection={props.errorCollection}
      onBeforeInput={props.onlyNumbers ? validateNumber : undefined}
      charactersType={props.onlyNumbers ? 'dígitos' : undefined}
      autocomplete={!props.onlyNumbers}
    />
  );
}
